/**
 * Import Lib
 */

import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import t from "theme";
/**
 * Import Context
 */

import { AppContext } from "context/appContext";
import { ContentContext } from "context/contentContext";

/**
 * import assets
 */

/**
 * import containers & components
 */

import Layout__container from "containers/layout/container/layout__container";
import Layout__content from "containers/layout/content/layout__content";
import { List__products, List__filters } from "components/list/list";
import { Content__banner, Content__condition } from "components/content/content";
import { Button__back } from "components/button/button";
import { Svg__scroll } from "components/svg/svg";

const Found = styled.p`
  margin-bottom: 43px;
  ${t.mixins.rem(20, 20)}
  font-family: ${t.font.primary};
  color: ${t.color.primary};
  text-align: center;

  ${t.mixins.sm(`
    margin-bottom: 36px;
    padding: 18px 40px 12px 40px;
    border-top: 1px solid ${t.color.grey};
    box-shadow: 0px 3px 5px 0 rgba(0, 0, 0, 0.3);
  `)}
`;
const Title = styled.span`
  line-height: 20px;
  font-weight: ${t.font.bold};
  border-bottom: 2px solid ${t.color.primary};

  ${t.mixins.sm(`
    display: inline-block;
`)}
`;
const Text = styled.span`
  ${t.mixins.sm(`
    display: block;
  `)}
`;
const Number = styled.span`
  line-height: 20px;
  font-size: 30px;
`;

/**
 * @name Products
 */

const Products = () => {
  const { c, content } = useContext(ContentContext);
  const { getFilteredProducts, getChoices, steps, filters } = useContext(AppContext);
  const products = getFilteredProducts();
  const quantity = products.length;
  const choices = getChoices();
  const history = useHistory();
  const back = () => {
    history.push("/");
  };
  const robotsKey = quantity < 2 ? c("home.products.robot") : c("home.products.robot_plural");
  const [isLoading, setIsLoading] = useState(true);
  let resultsRef = useRef();
  useEffect(() => {
    if (resultsRef.current) {
      resultsRef.current.scrollIntoView();
    }
  }, [isLoading])
  console.log(filters);

  return (
    <>
      <Layout__container pageName={content.products.config.page_name}>
        <div ref={resultsRef}></div>
        <Layout__content>
          <Button__back onClick={back} title={`${c("home.form.step")} ${steps.length}`} />
          <List__filters filters={filters} />
          <Found>
            <Text>{c("home.products.found")} </Text>
            <Title>
              <Number>{quantity}</Number> {robotsKey}
            </Title>{" "}
            <Text>{c("home.products.search")}</Text>
            <Svg__scroll />
          </Found>
          <List__products products={products} />
          <Content__condition content={c("home.products.condition")} />
        </Layout__content>
      </Layout__container>
      <Content__banner products={choices} />
    </>
  );
};

export default Products;
